import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import "./TopBar.css"
import { Dropdown } from 'react-bootstrap'
import ciLogo from "../../styles/Images/ci_logo.png"
import { GearFill } from 'react-bootstrap-icons';

const TopBar = ({ email, userRole }) => {
    const navigate = useNavigate();
    const { instance } = useMsal();

    const handleClick = () => {
        // alert('Admin menu clicked!');
        navigate('/admin');
    };

    const logout = () => {
        // instance.logoutRedirect();
        instance.logoutRedirect({
            postLogoutRedirectUri: "/",
        });
    }

    return (
        <>
            <div className="header-block fixed-top bg-white border-bottom">
                <div className="col-sm-12 col-lg12 col-md-12 ">
                    <div className="row" style={{ alignItems: 'center', marginTop: '7px' }}>
                        <div className="col-sm-3 col-md-3 col-lg-3 mr-md-1 mr-lg-2">
                            <div className="row" style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                                <div className="col d-flex justify-content-center">
                                    <img className="navbar-brand" src={ciLogo}
                                        alt="logo"
                                        style={{ cursor: 'pointer', objectFit: 'contain', width: '100%' }}
                                        onClick={() => navigate('/CMIHome')}
                                    />
                                </div>
                            </div>

                        </div>
                        {/* <div className="col-sm-6 col-md-auto col-lg-6"> */}
                        {/* <Menubar className="main-menu" model={menuItems} ></Menubar> */}
                        {/* </div> */}
                        <div className="col-sm-6 col-md-auto col-lg-6">
                            {userRole?.role === 'ADMIN' && <div
                                className="p-2 border rounded d-flex align-items-center"
                                style={{ cursor: 'pointer', width: 'fit-content' }}
                                onClick={handleClick}
                            >
                                <GearFill className="me-2" size={20} />
                                <span className="fw-bold">Admin</span>
                            </div>}
                        </div>
                        <div className="col-sm-3 col-md-3 col-lg-1 ml-auto mt-1 pl-0">
                            <Dropdown drop="down" >
                                <Dropdown.Toggle id="dropdown-basic">
                                    <i className="fa fa-user-circle-o"></i> <span className="username">
                                        {email || 'Unknown User'}
                                    </span>
                                </Dropdown.Toggle>
                            </Dropdown>

                        </div>
                    </div>
                </div>
            </div>

        </>
    );
};
export default TopBar;